export default {
    filters: 'Filter',
    filter: 'Filter',
    clearAll: 'Filter zurücksetzen',
    yes: 'Ja',
    no: 'Nein',
    setDefault: 'Standardwert setzen',
    showAll: 'Alle wählen',

    operator: {
        contains: 'enthält',
        oneOf: 'eine von',
        noneOf: 'keine von',
        yes: 'Ja',
        no: 'Nein',
        equals: 'ist gleich',
        startsWith: 'beginnt mit',
        endsWith: 'endet mit',
        greaterThan: 'ist größer als',
        lessThan: 'ist kleiner als',
        greaterThanOrEqual: 'ist größer oder gleich',
        lessThanOrEqual: 'ist kleiner oder gleich',
        inBetween: 'liegt im Bereich',
        notEquals: 'ist nicht gleich',
        intervalFrom: 'von',
        intervalTo: 'bis',
        after: 'nach',
        before: 'vor',
        on: 'am',
        notOn: 'nicht am',
    },

    saveFilters: 'Aktuelle Filterkombination speichern',
    saveFiltersDescription: 'Deine gespeicherten Filterkombinationen kannst du in den Nutzereinstellungen verwalten.',
    filterCombinationName: 'Name der Filterkombination',

    savedFilterCombinationSuccess: 'Die Filterkombination wurde erfolgreich gespeichert.',
    savedFilterCombinationError: 'Die Filterkombination konnte nicht gespeichert werden.',
}